module.exports = __webpack_public_path__ + "static/media/tick.4d8fe226.png";